import type {SymbolView} from "@gamzix/slot_core";
import {CONST} from "../../../src/const";

class GameSymbolView extends ReelsetComponent.src.SymbolView {
    async playLanding(): Promise<any> {
        if(this.store.gameData.bonusGame.isPlaying()) return;

        return super.playLanding();
    }

    public showCluster({ isRight, isLeft, isUp, isDown }, isNeedLockFrame) {
        // @ts-ignore
        this.view.spine.slotContainers[0].children[0].alpha = Number(isLeft);
        // @ts-ignore
        this.view.spine.slotContainers[1].children[0].alpha = Number(isRight);
        // @ts-ignore
        this.view.spine.slotContainers[2].children[0].alpha = Number(isDown);
        // @ts-ignore
        this.view.spine.slotContainers[3].children[0].alpha = Number(isUp);

        // enable symbol_bonus_bg
        // @ts-ignore
        this.view.children[1].options.visible = true;

        // enable symbol_bonus_bg
        // @ts-ignore
        this.view.children[2].options.visible = isNeedLockFrame;

        // @ts-ignore
        this.view.updateViewOptions();
    }

    public setOverlayView(newValue = null) {
        if (!GameSymbolView.bonusGameConfig.coinSymbolIds.includes(this.id)) return;

        // show value only on cluster into bonus game
        //@ts-ignore
        if ((this.store.gameData.bonusGame.isFirstSpinStart || this.store.gameData.bonusGame.isRestore) && !newValue) {
            return;
        }

        //@ts-ignore
        const textConfigView = SymbolView.symbolTextConfig.view;
        this.removeOverlayView();
        this.overlayView = game.builder.create(textConfigView);

        let value = this.store.gameData.reels[this.reelId][this.rowId]?.value;

        if (this.rowId < 0) {
            //@ts-ignore
            const randomValueIndex = Math.floor(Math.random() * (SymbolView.bonusGameConfig.fakeValues.length - 1));
            //@ts-ignore
            value = SymbolView.bonusGameConfig.fakeValues[randomValueIndex];
        }

        if (!value) return;

        if (newValue) {
            this.overlayView.options.text = this.store.toFormatMoney(newValue * this.store.gameData.bet);
        } else {
            this.overlayView.options.text = this.store.toFormatMoney(value * this.store.gameData.bet);
        }

        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);

        if (String(value) === CONST.JACKPOT.GOLD.multiplier.toString()) {
            this.setOverlayImage(CONST.JACKPOT.GOLD.name);
            return;
        } else if (String(value) === CONST.JACKPOT.SILVER.multiplier.toString()) {
            this.setOverlayImage(CONST.JACKPOT.SILVER.name);
            return;
        } else if (String(value) === CONST.JACKPOT.BRONZE.multiplier.toString()) {
            this.setOverlayImage(CONST.JACKPOT.BRONZE.name);
            return;
        }
    }

    setOverlayImage(name, scale = { x: 1, y: 1 }) {
        this.removeOverlayView();

        //@ts-ignore
        if (this.view.type === 'AnimatedSprite') {
            //@ts-ignore
            this.view.options.textures = [`B_${name}`];
            //@ts-ignore
            this.view.playAnimation()
        } else {
            //@ts-ignore
            this.view.setSkin(name);
        }

        this.overlayView = game.builder.create({type: "Sprite", texture: `coin_${name}`, scale: scale});
        this.overlayView.updateViewOptions();
        this.view.addChild(this.overlayView);
    }

    get store() {
        return game.store;
    }
}

//@ts-ignore
SlotGame.src.component.ReelsetComponent.src.SymbolView = GameSymbolView;